(function (angular) {
    angular.module('bizPartEngage').controller('modules.goals.activitylist', indexController);
    angular.module('bizPartEngage').controller('modules.goals.activity', activityController);

    indexController.$inject = ["modules.goals.service", "$stateParams"];
    activityController.$inject = ["modules.goals.service", "$stateParams"];

    function indexController(engagementGoalsService, $stateParams) {
        var vm = this;
                
           
        vm.$onInit = function () {            
         
        }
    }

    function activityController(engagementGoalsService, $stateParams) {
        var vm = this;     

        vm.activityId = ~~$stateParams.id;
        vm.goalId = ~~$stateParams.goalId;

        vm.SelectedPeriod = engagementGoalsService.GetSelectedPeriod();
        vm.Date = BizPartCoreHelpers.getDateNow();

        vm.GetOneActivity = GetOneActivity;
        vm.Back = Back;

        function Back() {
            window.history.back();
        }

        function GetOneActivity(id) {            
            engagementGoalsService.GetOneActivity(id).then(GetOneActivityCallback);

            function GetOneActivityCallback(response) {
                vm.activity = BizPartCoreHelpers.getResponseValue(response);                
            }
        }


        vm.$onInit = function () {
            if (vm.activityId > 0) {
                vm.GetOneActivity(vm.activityId);
            } else {                
                vm.activity = {
                    Id: 0,
                    GoalId: vm.goalId
                };
            }            
        }
    }

})(window.angular);
